import Layout from '@/layout'

const TenantMaintain = {
  path: '/TenantMaintain',
  component: Layout,
  redirect: 'noredirect',
  name: 'TenantMaintain',
  meta: {
    title: '',
    icon: 'daohang-ziliaoguanli'
    // roles: ['subsystem']
  },
  children: [
    {
      path: 'ChartConfigurationManagement',
      component: () => import('@/views/cargo/v0/TenantMaintain/chartConfigurationManagement'),
      name: 'ChartConfigurationManagement',
      meta: { title: '租户BI图表管理' },
      roles: []
    }
  ]
}

export default TenantMaintain
